export type StockTier = 'in_stock' | 'few_left' | 'out_of_stock' | 'unknown';

/**
 * Raw storefront quantity thresholds per ED-8 (no safety stock adjustment).
 */
export function getStockTierFromQuantity(
  quantity: number | null | undefined
): StockTier {
  if (quantity == null || Number.isNaN(quantity)) {
    return 'unknown';
  }
  if (quantity >= 5) return 'in_stock';
  if (quantity >= 1) return 'few_left';
  return 'out_of_stock';
}
